import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import Modal from '../../components/Modal';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import { Events } from '../../utils/dom/html-events';
import EventHandler from '../../utils/dom/event-handler';
import AffiliatedVenueSearchList from '../../components/AffiliatedVenueSearchList';
import Manipulator from '../../utils/dom/manipulator';

const QUESTION_DATA = {
	id: 2,
	step: 2,
	errorMessage: 'Please select the name of your venue',
	extraSubtitle: 'Your primary affiliated venue',
	fieldName: 'venueList',
	questionType: 'affiliateVenueSearchList',
	dependentQuestion: [3],
	visible: false
};
class AffiliatedVenue {
	constructor() {
		this._container = SelectorEngine.findOne('.js-edit-coach-details-venue');
		this.venueRefs = [];
		if (this._container) {
			this.init();
		}
	}

	init() {
		this.exitButtons = SelectorEngine.find('.lta-coach-details__edit-venue-back', this._container);
		this.exitModalElement = SelectorEngine.findOne('#coach-details-venue-exit', this._container);
		this.mainElement = SelectorEngine.findOne('.js-edit-coach-details-venue--list', this._container);
		this.saveChangesButton = SelectorEngine.findOne('.lta-coach-details__edit-venue-save', this._container);
		this.affiliatedVenueCheckbox = SelectorEngine.findOne('.lta-coach-details__edit-affiliated-venue-toggle .lta-toggle--checkbox', this._container);
		const modalCancelButton = SelectorEngine.findOne('.lta-coach-details__edit-venue-continue', this.exitModalElement);
		const modalContinueButton = SelectorEngine.findOne('.lta-coach-details__edit-venue-exit', this._container);
		this.exitModal = new Modal(this.exitModalElement, {});
		for (const exitButton of this.exitButtons) {
			EventHandler.on(exitButton, Events.Click, () => {
				this.showExitModal();
			});
		}

		EventHandler.on(this.saveChangesButton, Events.Click, () => {
			this.submitAPICallHandler();
		});

		EventHandler.on(modalCancelButton, Events.Click, () => {
			this.hideExitModal();
		});

		EventHandler.on(modalContinueButton, Events.Click, (event) => {
			this.hideExitModal();
			this.backToUrl(event);
		});
		this.initialAPICallHandler();
	}

	async initialAPICallHandler() {
		startLoadingAnimation(true);
		try {
			const url = `/api/coachdetails/getMyAffiliatedVenues`;
			const responseData = await Request.get(url);
			const { success, myAffiliatedVenues, redirectURL } = responseData;
			if (success) {
				this.questionData = {
					...QUESTION_DATA,
					redirectURL: redirectURL,
					myAffiliatedVenues
				};
				this.addInitialMarkUp();
			}
		} catch {
			// console.log('Error Block', error);
		} finally {
			stopLoadingAnimation();
		}
	}

	updateAnswerData(venueData) {
		const arrayData = [];
		for (let index = 0; index < venueData?.length; index++) {
			arrayData[index] = {
				id: venueData[index]?.venueID,
				venue: venueData[index]?.venue,
				role: venueData[index]?.role,
				address: venueData[index]?.address
			};
			if (venueData[index]?.operation) {
				arrayData[index].operation = venueData[index]?.operation;
			}
		}
		return arrayData;
	}

	async submitAPICallHandler() {
		if (!this.affiliatedVenueSearchList?.validate()) {
			return;
		}
		let checked = false;
		if(this.affiliatedVenueCheckbox) {
			checked = this.affiliatedVenueCheckbox.checked;
		}
		const venueData = {
			updateCoachDetailsRequest: {
				myAffiliatedVenues: this.updateAnswerData(this.affiliatedVenueSearchList?.value?.value),
				affiliatedVenuesVisibility: checked
			}
		};
		startLoadingAnimation(true);
		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, venueData);
			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			}
		} catch {
			// console.log('Error Block', error);
		} finally {
			stopLoadingAnimation();
		}
	}

	addInitialMarkUp() {
		this.affiliatedVenueSearchList = new AffiliatedVenueSearchList(this.mainElement, {
			data: { ...this.questionData }
		});
	}

	showExitModal() {
		this.exitModal.show();
	}

	hideExitModal() {
		this.exitModal.hide();
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const AffiliatedVenues = new AffiliatedVenue();
export default AffiliatedVenues;
